// extracted by mini-css-extract-plugin
export default {"Calendar":"bMpUb","Calendar--hasTime":"HU-Bo","Calendar--withoutMonthsNavigation":"_1dSfj","Calendar--isMobile":"tyiOk","skeleton-progress":"clYB5"};